import {
  carrierServiceTypes,
  locationListTypeValues,
  returnMethods,
} from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

export const carrierTypes = {
  [returnMethods.customerpickup]: carrierServiceTypes.homePickup,
  [returnMethods.pickuppoint]: carrierServiceTypes.dropoffPoint,
}

const commonConfig = {
  enabled_for_exchanges: false,
  enabled_for_refunds: false,
  enabled_for_mixed: false,
  net_order_amount: { type: 'greater_than', amount: 0.0 }, //TODO remove when back migrate availability rules
  extra_fee: 0.0,
  extra_fee_additional_transaction: 0.0,
  base_extra_fee: 0.0,
  base_extra_fee_additional_transaction: 0.0,
  extra_fee_included_items: 1,
  extra_fee_included_items_additional_transaction: 1,
  return_instruction_set_id: null,
  availability_criterion_ids: [],
  regions: [],
}

export const initialHomePickUpConfig = {
  ...commonConfig,
  carrier_service: {
    supports_modification: true,
  },
  time_ranges: [],
  supports_pickup_dates: false,
  type: returnMethods.customerpickup,
}

const initialReturnToStoreConfig = {
  ...commonConfig,
  url: '',
  type: returnMethods.returntostore,
  location_list_type: locationListTypeValues.url,
}

const initialPickUpPointConfig = {
  ...commonConfig,
  carrier: {
    supports_modification: true,
  },
  url: '',
  type: returnMethods.pickuppoint,
}

const initialCustomerDeliversConfig = {
  ...commonConfig,
  type: returnMethods.customerdelivers,
  delivery_address: {
    first_name: '',
    line_1: '',
    line_2: '',
    country: { region_id: null },
    province: { region_id: null },
    locality: '',
    postcode: '',
  },
}

export const initialConfigsByType = {
  [returnMethods.customerpickup]: initialHomePickUpConfig,
  [returnMethods.customerdelivers]: initialCustomerDeliversConfig,
  [returnMethods.pickuppoint]: initialPickUpPointConfig,
  [returnMethods.returntostore]: initialReturnToStoreConfig,
}
